
define( 'FORCES_AND_MOTION_BASICS/../nls/zh-tw/forces-and-motion-basics-strings',{
          "none": "無",
          "force": "力量",
          "values": "值",
          "frictionTitle": "摩擦",
          "redWins": "紅隊獲勝!",
          "frictionForce": "摩擦力",
          "pause": "暫停",
          "friction": "摩擦",
          "forces-and-motion-basics.name": "力量和運動:基本概念",
          "appliedForce": "作用力",
          "leftForce": "左邊力量",
          "massDisplay.pattern": "{0}公斤",
          "rightForce": "右邊力量",
          "sound": "聲音",
          "lots": "很多",
          "forces": "力量",
          "motion": "運動",
          "tugOfWar": "拔河",
          "go": "開始!",
          "newtons.n": "牛頓(N)",
          "sumOfForcesEqualsZero": "力量總合=0",
          "blueWins": "藍隊獲勝!",
          "speed": "速度",
          "sumOfForces": "力量總合",
          "return": "返回",
          "translation.credits": "陳國全 2012",
          "newtons": "牛頓",
          "masses": "資訊",
          "forceReadout.pattern": "{0}牛頓"
        } );